import { Auth,Storage,API } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { ReturnAddress } from './shared';

export const FindLocation = (lab, setLab, geoCodeShow, setGeoCodeShow, setCountry,setLocationErr) => {
  setGeoCodeShow(true)
  var currentLocation = lab
  navigator.geolocation.getCurrentPosition(position => {
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&result_type=street_address&key=AIzaSyAFcvBvnvSuJODbBydu9JLRLtBqNOOCZ30`)
    .then(response => response.json()).then(location => {
      console.log(location)
      if (location.status === "ZERO_RESULTS"){
        setLocationErr(true)
        setTimeout(function() {setLocationErr(false)}, 4000)
        setGeoCodeShow(undefined)
      } else {
        currentLocation.address.Country={CountryName: location.results[0].address_components[6].long_name, CountryCode: location.results[0].address_components[6].short_name}
        currentLocation.address_line_one = location.results[0].address_components[0].long_name + " " + location.results[0].address_components[1].long_name
        currentLocation.county = location.results[0].address_components[4].long_name
        currentLocation.city = location.results[0].address_components[3].long_name
        currentLocation.country = {CountryName: location.results[0].address_components[6].long_name, CountryCode: location.results[0].address_components[6].short_name}
        currentLocation.postcode = location.results[0].address_components[7].long_name
        setCountry({CountryName: location.results[0].address_components[6].long_name, CountryCode: location.results[0].address_components[6].short_name})
        setLab(currentLocation)
        setGeoCodeShow(undefined)
        console.log(currentLocation)
      }
    }).catch(err => {
      setLocationErr(true)
      setTimeout(function() {setLocationErr(false)}, 4000)
      setGeoCodeShow(undefined)
    })
  })
  
}

export const SignOut = (props, handleIsUserAuthenticated) => {
      Auth.signOut().catch(error => console.log(error))
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('isUserAuthenticated')
          sessionStorage.removeItem('username')
          sessionStorage.removeItem('email')
          window.location.reload(false);
}

export const SaveToAddressBook = (newAddress) => {
  const address = ReturnAddress(newAddress, 'addressBook')
  Auth.currentSession().then(session => {
    API
    .post("LabShip", "/addresses",
    { headers: { 
      Authorization: session.idToken.jwtToken,
    }, 
    body:{address: address}})
    .then(shipment => {
     this.props.history.push({pathname:'/addresses/all', edit:false, addressSucc: true})
   })
  })
}

export const uploadToS3 = (files,item,setItem,load,setLoad,documents,setDocuments) => {
  const s3Key = uuidv4()
  const file = files
  const fileName = files.name
  Storage.put(`${s3Key}/${fileName}`,file, {
    contentType: 'image/png'
  })
  .then (result => {
    console.log('Uploaded File', result)
  }) 
  .catch(err => console.log(err));
  return s3Key
}

export const uploadToS3Doc = (files,item,setItem,load,setLoad,documents,setDocuments) => {
  const s3Key = uuidv4()
  const file = files
  const fileName = files.name
  Storage.put(`${s3Key}/${fileName}`,file, {
    contentType: 'application/pdf'
  })
  .then (result => {
    console.log('Uploaded File', result)
  }) 
  .catch(err => console.log(err));
  return s3Key
}


export const handleDocsChange = (event, setDocuments) => {
  setDocuments(event.target.files[0])
};

export async function APIRequest(url){
  let response = Auth.currentSession().then(session => {
    var results = API.get("LabShip",url,{headers: { 
        Authorization: session.idToken.jwtToken,
      }})  
    .then(
      (result) => {
        return result
      },
      (error) => {
        console.log(error)
        return error
      }
    )
    return results
  })
  return response
}


// Function meant for Shadow Login of user by Admin - not possible at the moment.   
// export async function AdminUserLogin(props){
//   // props.history.push('/login')
//   let response = Auth.currentSession().then(session => {
//     var results = API.post("LabShip",`/auth/admin-shadow-sign-in?username=${props.value.username}`,{headers: { 
//         Authorization: session.idToken.jwtToken,
//       }})  
//     .then(
//       (result) => {
//         return result
//       },
//       (error) => {
//         console.log(error)
//         return error
//       }
//     )
//     return results
//   })
//   return response
// }